import { useEffect, useState } from "react";
import { useDashboard } from "../Dashboard/Hooks/useDashboard";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../Announcements/constants";

const AnnouncementsMarquee = () => {
  const [announcement, setAnnouncement] = useState([]);
  const { fetchAnnouncement } = useDashboard();

  const fetchData = async () => {
    try {
      const res = await fetchAnnouncement({insights: true});
      if (res?.results) {
        setAnnouncement(res.results);
      } else {
         setAnnouncement([]);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_ANNOUNCEMENT_ERROR);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (announcement.length === 0) {
    return (
      <div className="col-span-full rounded-2xl shadow-md bg-white flex justify-center items-center py-3 text-gray-400">
        No announcements available
      </div>
    );
  }

  return (
    <div className="col-span-full rounded-2xl flex flex-col md:flex-row items-center shadow-md bg-white p-2 overflow-hidden">
      <h2 className="text-lg font-semibold mr-4 flex-shrink-0 whitespace-nowrap">
        📢 Updates & Announcements
      </h2>

      <div className="flex-1 overflow-hidden">
        <marquee
          behavior="scroll"
          direction="left"
          scrollamount="5"
          className="whitespace-nowrap"
          onMouseOver={(e) => e.target.stop()}
          onMouseOut={(e) => e.target.start()}
        >
          {announcement.map((a, index) => (
            <a
              key={a.id}
              href={a.redirect_url || "#"}
              target={a.redirect_url ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="inline-block mr-6 whitespace-nowrap text-sm font-bold text-primary hover:text-blue-700 transition"
            >
              {index + 1}. {a.title}
            </a>
          ))}
        </marquee>
      </div>
    </div>
  );
};

export default AnnouncementsMarquee;
